import { debug } from "./debug";

/*------------------------------------*\
  #ANIMATIONS

  Class gestion des animations
\*------------------------------------*/
class Animation {
  constructor(){}

  /*------------------------------------*\
    #INITIALISATION
  \*------------------------------------*/
  init = () => {
    if(debug.DEBUG) console.log('helpers/Animation.js');
  }
  animateScroll = (scrollTopPosition, duration = 500, easing = 'easeInOutQuad') => {
    const scrollContainer = window.document.scrollingElement || window.document.documentElement || window.document.body;
    const start = scrollContainer.scrollTop;
    const change = scrollTopPosition - start;
    const startTime = performance.now();

    const easeInOutQuad = (t) => {
      t /= 0.5;
      if (t < 1) return 0.5 * t * t;
      t--;
      return -0.5 * (t * (t - 2) - 1);
    };

    const animateScroll = (currentTime) => {
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);
      const easingFunction = easeInOutQuad(progress);
      scrollContainer.scrollTop = start + change * easingFunction;

      if (timeElapsed < duration) {
        requestAnimationFrame(animateScroll);
      }
    };

    requestAnimationFrame(animateScroll);
  }
  scrollTo = (scrollTopPosition, _duration) => {
    
    let duration = _duration !== undefined ? _duration : 500;
    var scrollContainer = window.document.scrollingElement || window.document.documentElement || window.document.body;
    this.animateScroll(scrollTopPosition, duration);
  }
}
export const animation = new Animation(); 
document.addEventListener("DOMContentLoaded", function() {
  animation.init();
});